import { CMSResult } from "../services/cmsClient";
import { Result, Err, Ok } from "@pairtreefamily/utils";

type DocumentData<T> = T | Array<T & { _id: string }>;

function _getSingleDocumentData<T>(
  data: DocumentData<T>,
  preview?: boolean,
): Result<T, string> {
  if (!data) {
    return Err("getSingleDocumentData argument is falsey");
  }

  if (!Array.isArray(data)) {
    // return single result
    return Ok(data);
  }

  if (data.length < 1) {
    return Err("getSingleDocumentData argument is empty array");
  }

  const firstItem: T = data[0];

  if (preview) {
    // return first draft if preview is true
    const firstDraft =
      data.find((item) => item._id.startsWith("drafts.")) || firstItem;
    return Ok(firstDraft);
  }

  // return first item as a last resort
  return Ok(firstItem);
}

// receives a list of documents and returns a single one
// if the list is empty, returns null
// if `preview` is true, returns the first draft document
// otherwise returns the first document
export function getSingleDocumentData<T>(
  data: DocumentData<T> | CMSResult<DocumentData<T>>,
  preview?: boolean,
): Result<T, string> {
  // @ts-ignore TODO: fix this
  if ("ok" in data) {
    if (data.ok) {
      return _getSingleDocumentData(data.content, preview);
    }
    return data;
  }
  return _getSingleDocumentData(data, preview);
}
